// import React from "react";
// import "./Sidebar.css";

// const Sidebar = ({
//     role,
//     userData,
//     activeModule,
//     openMenus,
//     toggleSubMenu,
//     handleModuleChange,
//     handleLogout,
//     mobileMenuOpen,
//     setMobileMenuOpen,
//        pendingRequestsCount,
// }) => {

//     return (
//         <>
//             <button
//                 className="drawer-menu-btn"
//                 onClick={() => setMobileMenuOpen(true)}
//             >
//                 ☰ Menu
//             </button>

//             {mobileMenuOpen && (
//                 <div
//                     className="drawer-overlay"
//                     onClick={() => setMobileMenuOpen(false)}
//                 />
//             )}

//             <aside
//                 className={`drawer-sidebar ${mobileMenuOpen ? "drawer-open" : ""}`}
//             >
//                 {/* TOP */}
//                 <div className="drawer-top">
//                     {/* PROFILE */}
//                     <div
//                         className="logo-circle profile-logo"
//                         onClick={() => {
//                             handleModuleChange("my-profile");
//                             setMobileMenuOpen(false);
//                         }}
//                     >
//                         {userData?.profileImage ? (
//                             <img
//                                 src={userData.profileImage}
//                                 alt="profile"
//                                 className="sidebar-avatar-img"
//                             />
//                         ) : (
//                             userData?.firstName?.charAt(0)
//                         )}
//                     </div>

//                     {/* DASHBOARD */}
//                     <div
//                         className={`drawer-item ${activeModule === "grid" ? "active" : ""
//                             }`}
//                         onClick={() => {
//                             handleModuleChange("grid");
//                             setMobileMenuOpen(false);
//                         }}
//                     >
//                         🏠
//                         <span>Dashboard</span>
//                     </div>

//                     {role === "Manager" && (
//                         <div
//                             className="drawer-item"
//                             onClick={() => {
//                                 handleModuleChange("one-on-one");
//                                 setMobileMenuOpen(false);
//                             }}
//                         >
//                             💬
//                             <span>1-1 Sessions</span>
//                         </div>
//                     )}

//                     {role === "Management" && (
//                         <>
//                             <div className="drawer-dropdown">
//                                 <div
//                                     className="drawer-item"
//                                     onClick={() => toggleSubMenu("department")}
//                                 >
//                                     🏢
//                                     <span>Department</span>
//                                     <span
//                                         className={`arrow ${openMenus.department ? "open" : ""
//                                             }`}
//                                     ></span>
//                                 </div>

//                                 {openMenus.department && (
//                                     <div className="drawer-submenu">
//                                         <div
//                                             className="drawer-subitem"
//                                             onClick={() => {
//                                                 handleModuleChange("add-department");
//                                                 setMobileMenuOpen(false);
//                                             }}
//                                         >
//                                             <span>➕ Add Dept</span>
//                                         </div>

//                                         <div
//                                             className="drawer-subitem"
//                                             onClick={() => {
//                                                 handleModuleChange("manage-department");
//                                                 setMobileMenuOpen(false);
//                                             }}
//                                         >
//                                             ⚙ Manage Dept
//                                         </div>
//                                     </div>
//                                 )}
//                             </div>

//                             <div className="drawer-dropdown">
//                                 <div
//                                     className="drawer-item"
//                                     onClick={() => toggleSubMenu("employee")}
//                                 >
//                                     👥
//                                     <span>Employee</span>
//                                     <span
//                                         className={`arrow ${openMenus.employee ? "open" : ""
//                                             }`}
//                                     ></span>
//                                 </div>

//                                 {openMenus.employee && (
//                                     <div className="drawer-submenu">
//                                         <div
//                                             className="drawer-subitem"
//                                             onClick={() => {
//                                                 handleModuleChange("add-employee");
//                                                 setMobileMenuOpen(false);
//                                             }}
//                                         >
//                                             <span>➕ Add Emp</span>
//                                         </div>

//                                         <div
//                                             className="drawer-subitem"
//                                             onClick={() => {
//                                                 handleModuleChange("manage-employee");
//                                                 setMobileMenuOpen(false);
//                                             }}
//                                         >
//                                             ⚙ Manage Emp
//                                         </div>
//                                     </div>
//                                 )}
//                             </div>

//                             <div
//                                 className="drawer-item"
//                                 onClick={() => {
//                                     handleModuleChange("employee-salary-benefits");
//                                     setMobileMenuOpen(false);
//                                 }}
//                             >
//                                 💰
//                                 <span>Salary</span>
//                             </div>
//                         </>
//                     )}

//                     {(role === "Management" || role === "Manager") && (
//                         <div
//                             className="drawer-item"
//                             onClick={() =>
//                             (window.location.href =
//                                 "https://hiring.gtelinq.com")
//                             }
//                         >
//                             💼
//                             <span>Hiring Hub</span>
//                         </div>
//                     )}

//                     {/* <div
//                         onClick={() => {
//                             handleModuleChange("equipment-request");
//                             setMobileMenuOpen(false);
//                         }}
//                         className="drawer-item"
//                     >
//                         💻
//                         <span>
//                             {role === "Management"
//                                 ? "IT Request"
//                                 : "IT Support"}
//                         </span>
//                     </div> */}


// <div
//     onClick={() => {
//         handleModuleChange("equipment-request");
//         setMobileMenuOpen(false);
//     }}
//     className="drawer-item"
// >
//     <div className="sidebar-icon-wrapper">
//         💻

//         {role === "Management" && pendingRequestsCount > 0 && (
//             <span className="sidebar-notification-badge">
//                 {pendingRequestsCount}
//             </span>
//         )}
//     </div>

//     <span>
//         {role === "Management"
//             ? "IT Request"
//             : "IT Support"}
//     </span>
// </div>
                    

//                     {(role === "Management" || role === "Manager") && (
//                         <div
//                             className="drawer-item"
//                             onClick={() => {
//                                 handleModuleChange("manage-quarterly-updates");
//                                 setMobileMenuOpen(false);
//                             }}
//                         >
//                             📢
//                             <span>ACM Updates</span>
//                         </div>
//                     )}

//                     <div
//                         onClick={() => {
//                             handleModuleChange("Organization Chart");
//                             setMobileMenuOpen(false);
//                         }}
//                         className="drawer-item"
//                     >
//                         👥
//                         <span>Org</span>
//                     </div>

//                     <div
//                         onClick={() => {
//                             handleModuleChange("campus information");
//                             setMobileMenuOpen(false);
//                         }}
//                         className="drawer-item"
//                     >
//                         🏢
//                         <span>Campus</span>
//                     </div>

//                     <div
//                         onClick={() => {
//                             handleModuleChange("company-policy");
//                             setMobileMenuOpen(false);
//                         }}
//                         className="drawer-item"
//                     >
//                         📜
//                         <span>Policy</span>
//                     </div>

//                     <div
//                         onClick={() => {
//                             handleModuleChange("my-profile");
//                             setMobileMenuOpen(false);
//                         }}
//                         className="drawer-item"
//                     >
//                         👤
//                         <span>Profile</span>
//                     </div>


//                 </div>
//                 <div
//                     onClick={handleLogout}
//                     className="drawer-item logout"
//                     style={{
//                         marginTop: "auto",
//                         flexShrink: 0
//                     }}
//                 >
//                     ⏻
//                     <span>Logout</span>
//                 </div>


//             </aside>
//         </>
//     );
// };

// export default Sidebar;





















// working before document 


// import React from "react";
// import "./Sidebar.css";

// const Sidebar = ({
//     role,
//     userData,
//     activeModule,
//     openMenus,
//     toggleSubMenu,
//     handleModuleChange,
//     handleLogout,
//     mobileMenuOpen,
//     setMobileMenuOpen,
//     pendingRequestsCount,
// }) => {

//     return (
//         <>
//             <button
//                 className="drawer-menu-btn"
//                 onClick={() => setMobileMenuOpen(true)}
//             >
//                 ☰ Menu
//             </button>

//             {mobileMenuOpen && (
//                 <div
//                     className="drawer-overlay"
//                     onClick={() => setMobileMenuOpen(false)}
//                 />
//             )}

//             <aside
//                 className={`drawer-sidebar ${mobileMenuOpen ? "drawer-open" : ""}`}
//             >
//                 {/* TOP */}
//                 <div className="drawer-top">
//                     {/* PROFILE */}
//                     <div
//                         className="logo-circle profile-logo"
//                         onClick={() => {
//                             handleModuleChange("my-profile");
//                             setMobileMenuOpen(false);
//                         }}
//                     >
//                         {userData?.profileImage ? (
//                             <img
//                                 src={userData.profileImage}
//                                 alt="profile"
//                                 className="sidebar-avatar-img"
//                             />
//                         ) : (
//                             userData?.firstName?.charAt(0)
//                         )}
//                     </div>

//                     {/* DASHBOARD */}
//                     <div
//                         className={`drawer-item ${activeModule === "grid" ? "active" : ""
//                             }`}
//                         onClick={() => {
//                             handleModuleChange("grid");
//                             setMobileMenuOpen(false);
//                         }}
//                     >
//                         🏠
//                         <span>Dashboard</span>
//                     </div>

//                     {role === "Manager" && (
//                         <div
//                             className="drawer-item"
//                             onClick={() => {
//                                 handleModuleChange("one-on-one");
//                                 setMobileMenuOpen(false);
//                             }}
//                         >
//                             💬
//                             <span>1-1 Sessions</span>
//                         </div>
//                     )}

//                     {role === "Management" && (
//                         <>
//                             <div className="drawer-dropdown">
//                                 <div
//                                     className="drawer-item"
//                                     onClick={() => toggleSubMenu("department")}
//                                 >
//                                     🏢
//                                     <span>Department</span>
//                                     <span
//                                         className={`arrow ${openMenus.department ? "open" : ""
//                                             }`}
//                                     ></span>
//                                 </div>

//                                 {openMenus.department && (
//                                     <div className="drawer-submenu">
//                                         <div
//                                             className="drawer-subitem"
//                                             onClick={() => {
//                                                 handleModuleChange("add-department");
//                                                 setMobileMenuOpen(false);
//                                             }}
//                                         >
//                                             <span>➕ Add Dept</span>
//                                         </div>

//                                         <div
//                                             className="drawer-subitem"
//                                             onClick={() => {
//                                                 handleModuleChange("manage-department");
//                                                 setMobileMenuOpen(false);
//                                             }}
//                                         >
//                                             ⚙ Manage Dept
//                                         </div>
//                                     </div>
//                                 )}
//                             </div>

//                             <div className="drawer-dropdown">
//                                 <div
//                                     className="drawer-item"
//                                     onClick={() => toggleSubMenu("employee")}
//                                 >
//                                     👥
//                                     <span>Employee</span>
//                                     <span
//                                         className={`arrow ${openMenus.employee ? "open" : ""
//                                             }`}
//                                     ></span>
//                                 </div>

//                                 {openMenus.employee && (
//                                     <div className="drawer-submenu">
//                                         <div
//                                             className="drawer-subitem"
//                                             onClick={() => {
//                                                 handleModuleChange("add-employee");
//                                                 setMobileMenuOpen(false);
//                                             }}
//                                         >
//                                             <span>➕ Add Emp</span>
//                                         </div>

//                                         <div
//                                             className="drawer-subitem"
//                                             onClick={() => {
//                                                 handleModuleChange("manage-employee");
//                                                 setMobileMenuOpen(false);
//                                             }}
//                                         >
//                                             ⚙ Manage Emp
//                                         </div>
//                                     </div>
//                                 )}
//                             </div>

//                             <div
//                                 className="drawer-item"
//                                 onClick={() => {
//                                     handleModuleChange("employee-salary-benefits");
//                                     setMobileMenuOpen(false);
//                                 }}
//                             >
//                                 💰
//                                 <span>Salary</span>
//                             </div>
//                         </>
//                     )}

//                     {(role === "Management" || role === "Manager") && (
//                         <div
//                             className="drawer-item"
//                             onClick={() =>
//                             (window.location.href =
//                                 "https://hiring.gtelinq.com")
//                             }
//                         >
//                             💼
//                             <span>Hiring Hub</span>
//                         </div>
//                     )}

//                     {/* <div
//                         onClick={() => {
//                             handleModuleChange("equipment-request");
//                             setMobileMenuOpen(false);
//                         }}
//                         className="drawer-item"
//                     >
//                         💻
//                         <span>
//                             {role === "Management"
//                                 ? "IT Request"
//                                 : "IT Support"}
//                         </span>
//                     </div> */}


//                     <div
//                         onClick={() => {
//                             handleModuleChange("equipment-request");
//                             setMobileMenuOpen(false);
//                         }}
//                         className="drawer-item"
//                     >
//                         <div className="sidebar-icon-wrapper">
//                             💻

//                             {role === "Management" && pendingRequestsCount > 0 && (
//                                 <span className="sidebar-notification-badge">
//                                     {pendingRequestsCount}
//                                 </span>
//                             )}
//                         </div>

//                         <span>
//                             {role === "Management"
//                                 ? "IT Request"
//                                 : "IT Support"}
//                         </span>
//                     </div>


//                     {(role === "Management" || role === "Manager") && (
//                         <div
//                             className="drawer-item"
//                             onClick={() => {
//                                 handleModuleChange("manage-quarterly-updates");
//                                 setMobileMenuOpen(false);
//                             }}
//                         >
//                             📢
//                             <span>ACM Updates</span>
//                         </div>
//                     )}

//                     <div
//                         onClick={() => {
//                             handleModuleChange("Organization Chart");
//                             setMobileMenuOpen(false);
//                         }}
//                         className="drawer-item"
//                     >
//                         👥
//                         <span>Org</span>
//                     </div>

//                     <div
//                         onClick={() => {
//                             handleModuleChange("campus information");
//                             setMobileMenuOpen(false);
//                         }}
//                         className="drawer-item"
//                     >
//                         🏢
//                         <span>Campus</span>
//                     </div>

//                     <div
//                         onClick={() => {
//                             handleModuleChange("company-policy");
//                             setMobileMenuOpen(false);
//                         }}
//                         className="drawer-item"
//                     >
//                         📜
//                         <span>Policy</span>
//                     </div>

//                     {/* <div
//                         onClick={() => {
//                             handleModuleChange("award-nominations");
//                             setMobileMenuOpen(false);
//                         }}
//                         className={`drawer-item ${activeModule === "award-nominations" ? "active" : ""}`}
//                     >
//                         🏆
//                         <span>Award Nominations</span>
//                     </div> */}

//                     <div
//                         onClick={() => {
//                             handleModuleChange("my-profile");
//                             setMobileMenuOpen(false);
//                         }}
//                         className="drawer-item"
//                     >
//                         👤
//                         <span>Profile</span>
//                     </div>


//                 </div>
//                 <div
//                     onClick={handleLogout}
//                     className="drawer-item logout"
//                     style={{
//                         marginTop: "auto",
//                         flexShrink: 0
//                     }}
//                 >
//                     ⏻
//                     <span>Logout</span>
//                 </div>


//             </aside>
//         </>
//     );
// };

// export default Sidebar;


















// import React from "react";
// import "./Sidebar.css";

// const Sidebar = ({
//     role,
//     userData,
//     activeModule,
//     openMenus,
//     toggleSubMenu,
//     handleModuleChange,
//     handleLogout,
//     mobileMenuOpen,
//     setMobileMenuOpen,
//     pendingRequestsCount,
// }) => {

//     return (
//         <>
//             <button
//                 className="drawer-menu-btn"
//                 onClick={() => setMobileMenuOpen(true)}
//             >
//                 ☰ Menu
//             </button>

//             {mobileMenuOpen && (
//                 <div
//                     className="drawer-overlay"
//                     onClick={() => setMobileMenuOpen(false)}
//                 />
//             )}

//             <aside
//                 className={`drawer-sidebar ${mobileMenuOpen ? "drawer-open" : ""}`}
//             >
//                 {/* TOP */}
//                 <div className="drawer-top">
//                     {/* PROFILE */}
//                     <div
//                         className="logo-circle profile-logo"
//                         onClick={() => {
//                             handleModuleChange("my-profile");
//                             setMobileMenuOpen(false);
//                         }}
//                     >
//                         {userData?.profileImage ? (
//                             <img
//                                 src={userData.profileImage}
//                                 alt="profile"
//                                 className="sidebar-avatar-img"
//                             />
//                         ) : (
//                             userData?.firstName?.charAt(0)
//                         )}
//                     </div>

//                     {/* DASHBOARD */}
//                     <div
//                         className={`drawer-item ${activeModule === "grid" ? "active" : ""
//                             }`}
//                         onClick={() => {
//                             handleModuleChange("grid");
//                             setMobileMenuOpen(false);
//                         }}
//                     >
//                         🏠
//                         <span>Dashboard</span>
//                     </div>

//                     {role === "Manager" && (
//                         <div
//                             className="drawer-item"
//                             onClick={() => {
//                                 handleModuleChange("one-on-one");
//                                 setMobileMenuOpen(false);
//                             }}
//                         >
//                             💬
//                             <span>1-1 Sessions</span>
//                         </div>
//                     )}

//                     {role === "Management" && (
//                         <>
//                             <div className="drawer-dropdown">
//                                 <div
//                                     className="drawer-item"
//                                     onClick={() => toggleSubMenu("department")}
//                                 >
//                                     🏢
//                                     <span>Department</span>
//                                     <span
//                                         className={`arrow ${openMenus.department ? "open" : ""
//                                             }`}
//                                     ></span>
//                                 </div>

//                                 {openMenus.department && (
//                                     <div className="drawer-submenu">
//                                         <div
//                                             className="drawer-subitem"
//                                             onClick={() => {
//                                                 handleModuleChange("add-department");
//                                                 setMobileMenuOpen(false);
//                                             }}
//                                         >
//                                             <span>➕ Add Dept</span>
//                                         </div>

//                                         <div
//                                             className="drawer-subitem"
//                                             onClick={() => {
//                                                 handleModuleChange("manage-department");
//                                                 setMobileMenuOpen(false);
//                                             }}
//                                         >
//                                             ⚙ Manage Dept
//                                         </div>
//                                     </div>
//                                 )}
//                             </div>

//                             <div className="drawer-dropdown">
//                                 <div
//                                     className="drawer-item"
//                                     onClick={() => toggleSubMenu("employee")}
//                                 >
//                                     👥
//                                     <span>Employee</span>
//                                     <span
//                                         className={`arrow ${openMenus.employee ? "open" : ""
//                                             }`}
//                                     ></span>
//                                 </div>

//                                 {openMenus.employee && (
//                                     <div className="drawer-submenu">
//                                         <div
//                                             className="drawer-subitem"
//                                             onClick={() => {
//                                                 handleModuleChange("add-employee");
//                                                 setMobileMenuOpen(false);
//                                             }}
//                                         >
//                                             <span>➕ Add Emp</span>
//                                         </div>

//                                         <div
//                                             className="drawer-subitem"
//                                             onClick={() => {
//                                                 handleModuleChange("manage-employee");
//                                                 setMobileMenuOpen(false);
//                                             }}
//                                         >
//                                             ⚙ Manage Emp
//                                         </div>
//                                     </div>
//                                 )}
//                             </div>

//                             <div
//                                 className="drawer-item"
//                                 onClick={() => {
//                                     handleModuleChange("employee-salary-benefits");
//                                     setMobileMenuOpen(false);
//                                 }}
//                             >
//                                 💰
//                                 <span>Salary</span>
//                             </div>

//                             <div
//                                 className={`drawer-item ${activeModule === "documents" ? "active" : ""}`}
//                                 onClick={() => {
//                                     handleModuleChange("documents");
//                                     setMobileMenuOpen(false);
//                                 }}
//                             >
//                                 📁
//                                 <span>Documents</span>
//                             </div>
//                         </>
//                     )}

//                     {(role === "Management" || role === "Manager") && (
//                         <div
//                             className="drawer-item"
//                             onClick={() =>
//                             (window.location.href =
//                                 "https://hiring.gtelinq.com")
//                             }
//                         >
//                             💼
//                             <span>Hiring Hub</span>
//                         </div>
//                     )}

                   


//                     <div
//                         onClick={() => {
//                             handleModuleChange("equipment-request");
//                             setMobileMenuOpen(false);
//                         }}
//                         className="drawer-item"
//                     >
//                         <div className="sidebar-icon-wrapper">
//                             💻

//                             {role === "Management" && pendingRequestsCount > 0 && (
//                                 <span className="sidebar-notification-badge">
//                                     {pendingRequestsCount}
//                                 </span>
//                             )}
//                         </div>

//                         <span>
//                             {role === "Management"
//                                 ? "IT Request"
//                                 : "IT Support"}
//                         </span>
//                     </div>


//                     {(role === "Management" || role === "Manager") && (
//                         <div
//                             className="drawer-item"
//                             onClick={() => {
//                                 handleModuleChange("manage-quarterly-updates");
//                                 setMobileMenuOpen(false);
//                             }}
//                         >
//                             📢
//                             <span>ACM Updates</span>
//                         </div>
//                     )}

//                     <div
//                         onClick={() => {
//                             handleModuleChange("Organization Chart");
//                             setMobileMenuOpen(false);
//                         }}
//                         className="drawer-item"
//                     >
//                         👥
//                         <span>Org</span>
//                     </div>

//                     <div
//                         onClick={() => {
//                             handleModuleChange("campus information");
//                             setMobileMenuOpen(false);
//                         }}
//                         className="drawer-item"
//                     >
//                         🏢
//                         <span>Campus</span>
//                     </div>

//                     <div
//                         onClick={() => {
//                             handleModuleChange("company-policy");
//                             setMobileMenuOpen(false);
//                         }}
//                         className="drawer-item"
//                     >
//                         📜
//                         <span>Policy</span>
//                     </div>

//                     {/* <div
//                         onClick={() => {
//                             handleModuleChange("award-nominations");
//                             setMobileMenuOpen(false);
//                         }}
//                         className={`drawer-item ${activeModule === "award-nominations" ? "active" : ""}`}
//                     >
//                         🏆
//                         <span>Award Nominations</span>
//                     </div> */}

//                     {role !== "Management" && (
//                         <div
//                             onClick={() => {
//                                 handleModuleChange("documents");
//                                 setMobileMenuOpen(false);
//                             }}
//                             className={`drawer-item ${activeModule === "documents" ? "active" : ""}`}
//                         >
//                             📁
//                             <span>Documents</span>
//                         </div>
//                     )}

//                     <div
//                         onClick={() => {
//                             handleModuleChange("my-profile");
//                             setMobileMenuOpen(false);
//                         }}
//                         className="drawer-item"
//                     >
//                         👤
//                         <span>Profile</span>
//                     </div>


//                 </div>
//                 <div
//                     onClick={handleLogout}
//                     className="drawer-item logout"
//                     style={{
//                         marginTop: "auto",
//                         flexShrink: 0
//                     }}
//                 >
//                     ⏻
//                     <span>Logout</span>
//                 </div>


//             </aside>
//         </>
//     );
// };

// export default Sidebar;































import React from "react";
import "./Sidebar.css";

const Sidebar = ({
    role,
    userData,
    activeModule,
    openMenus,
    toggleSubMenu,
    handleModuleChange,
    handleLogout,
    mobileMenuOpen,
    setMobileMenuOpen,
    pendingRequestsCount,
}) => {

    // Check: role = Employee and Designation = HR Associate
    const userRole = (role || userData?.role || userData?.Role || "").toString().trim().toLowerCase();
    const userDesignation = (userData?.designation || userData?.Designation || "").toString().trim().toLowerCase();

    const isHRAssociate =
        (userRole === "employee" || userRole === "hr") &&
        userDesignation === "hr associate";

    return (
        <>
            <button
                className="drawer-menu-btn"
                onClick={() => setMobileMenuOpen(true)}
            >
                ☰ Menu
            </button>

            {mobileMenuOpen && (
                <div
                    className="drawer-overlay"
                    onClick={() => setMobileMenuOpen(false)}
                />
            )}

            <aside
                className={`drawer-sidebar ${mobileMenuOpen ? "drawer-open" : ""}`}
            >
                {/* TOP */}
                <div className="drawer-top">
                    {/* PROFILE */}
                    <div
                        className="logo-circle profile-logo"
                        onClick={() => {
                            handleModuleChange("my-profile");
                            setMobileMenuOpen(false);
                        }}
                    >
                        {userData?.profileImage ? (
                            <img
                                src={userData.profileImage}
                                alt="profile"
                                className="sidebar-avatar-img"
                            />
                        ) : (
                            userData?.firstName?.charAt(0)
                        )}
                    </div>

                    {/* DASHBOARD */}
                    <div
                        className={`drawer-item ${activeModule === "grid" ? "active" : ""
                            }`}
                        onClick={() => {
                            handleModuleChange("grid");
                            setMobileMenuOpen(false);
                        }}
                    >
                        🏠
                        <span>Dashboard</span>
                    </div>

                    {role === "Manager" && (
                        <div
                            className="drawer-item"
                            onClick={() => {
                                handleModuleChange("one-on-one");
                                setMobileMenuOpen(false);
                            }}
                        >
                            💬
                            <span>1-1 Sessions</span>
                        </div>
                    )}

                    {role === "Management" && (
                        <>
                            <div className="drawer-dropdown">
                                <div
                                    className="drawer-item"
                                    onClick={() => toggleSubMenu("department")}
                                >
                                    🏢
                                    <span>Department</span>
                                    <span
                                        className={`arrow ${openMenus.department ? "open" : ""
                                            }`}
                                    ></span>
                                </div>

                                {openMenus.department && (
                                    <div className="drawer-submenu">
                                        <div
                                            className="drawer-subitem"
                                            onClick={() => {
                                                handleModuleChange("add-department");
                                                setMobileMenuOpen(false);
                                            }}
                                        >
                                            <span>➕ Add Dept</span>
                                        </div>

                                        <div
                                            className="drawer-subitem"
                                            onClick={() => {
                                                handleModuleChange("manage-department");
                                                setMobileMenuOpen(false);
                                            }}
                                        >
                                            ⚙ Manage Dept
                                        </div>
                                    </div>
                                )}
                            </div>

                            <div className="drawer-dropdown">
                                <div
                                    className="drawer-item"
                                    onClick={() => toggleSubMenu("employee")}
                                >
                                    👥
                                    <span>Employee</span>
                                    <span
                                        className={`arrow ${openMenus.employee ? "open" : ""
                                            }`}
                                    ></span>
                                </div>

                                {openMenus.employee && (
                                    <div className="drawer-submenu">
                                        <div
                                            className="drawer-subitem"
                                            onClick={() => {
                                                handleModuleChange("add-employee");
                                                setMobileMenuOpen(false);
                                            }}
                                        >
                                            <span>➕ Add Emp</span>
                                        </div>

                                        <div
                                            className="drawer-subitem"
                                            onClick={() => {
                                                handleModuleChange("manage-employee");
                                                setMobileMenuOpen(false);
                                            }}
                                        >
                                            ⚙ Manage Emp
                                        </div>
                                    </div>
                                )}
                            </div>

                            <div
                                className="drawer-item"
                                onClick={() => {
                                    handleModuleChange("employee-salary-benefits");
                                    setMobileMenuOpen(false);
                                }}
                            >
                                💰
                                <span>Salary</span>
                            </div>

                            <div
                                className={`drawer-item ${activeModule === "documents" ? "active" : ""}`}
                                onClick={() => {
                                    handleModuleChange("documents");
                                    setMobileMenuOpen(false);
                                }}
                            >
                                📁
                                <span>Documents</span>
                            </div>
                        </>
                    )}

                    {/* HR ASSOCIATE (Role: Employee, Designation: HR Associate): ONLY Add Employee Section */}
                    {isHRAssociate && role !== "Management" && (
                        <div className="drawer-dropdown">
                            <div
                                className={`drawer-item ${activeModule === "add-employee" ? "active" : ""}`}
                                onClick={() => toggleSubMenu("employee")}
                            >
                                👥
                                <span>Employee</span>
                                <span
                                    className={`arrow ${openMenus?.employee || activeModule === "add-employee" ? "open" : ""}`}
                                ></span>
                            </div>

                            {(openMenus?.employee || activeModule === "add-employee") && (
                                <div className="drawer-submenu">
                                    <div
                                        className={`drawer-subitem ${activeModule === "add-employee" ? "active" : ""}`}
                                        onClick={() => {
                                            handleModuleChange("add-employee");
                                            setMobileMenuOpen(false);
                                        }}
                                    >
                                        <span>➕ Add Emp</span>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}

                    {(role === "Management" || role === "Manager") && (
                        <div
                            className="drawer-item"
                            onClick={() =>
                            (window.location.href =
                                "https://hiring.gtelinq.com")
                            }
                        >
                            💼
                            <span>Hiring Hub</span>
                        </div>
                    )}

                   


                    <div
                        onClick={() => {
                            handleModuleChange("equipment-request");
                            setMobileMenuOpen(false);
                        }}
                        className="drawer-item"
                    >
                        <div className="sidebar-icon-wrapper">
                            💻

                            {role === "Management" && pendingRequestsCount > 0 && (
                                <span className="sidebar-notification-badge">
                                    {pendingRequestsCount}
                                </span>
                            )}
                        </div>

                        <span>
                            {role === "Management"
                                ? "IT Request"
                                : "IT Support"}
                        </span>
                    </div>


                    {(role === "Management" || role === "Manager") && (
                        <div
                            className="drawer-item"
                            onClick={() => {
                                handleModuleChange("manage-quarterly-updates");
                                setMobileMenuOpen(false);
                            }}
                        >
                            📢
                            <span>ACM Updates</span>
                        </div>
                    )}

                    <div
                        onClick={() => {
                            handleModuleChange("Organization Chart");
                            setMobileMenuOpen(false);
                        }}
                        className="drawer-item"
                    >
                        👥
                        <span>Org</span>
                    </div>

                    <div
                        onClick={() => {
                            handleModuleChange("campus information");
                            setMobileMenuOpen(false);
                        }}
                        className="drawer-item"
                    >
                        🏢
                        <span>Campus</span>
                    </div>

                    <div
                        onClick={() => {
                            handleModuleChange("company-policy");
                            setMobileMenuOpen(false);
                        }}
                        className="drawer-item"
                    >
                        📜
                        <span>Policy</span>
                    </div>

                    {/* <div
                        onClick={() => {
                            handleModuleChange("award-nominations");
                            setMobileMenuOpen(false);
                        }}
                        className={`drawer-item ${activeModule === "award-nominations" ? "active" : ""}`}
                    >
                        🏆
                        <span>Award Nominations</span>
                    </div> */}

                    {role !== "Management" && (
                        <div
                            onClick={() => {
                                handleModuleChange("documents");
                                setMobileMenuOpen(false);
                            }}
                            className={`drawer-item ${activeModule === "documents" ? "active" : ""}`}
                        >
                            📁
                            <span>Documents</span>
                        </div>
                    )}

                    <div
                        onClick={() => {
                            handleModuleChange("my-profile");
                            setMobileMenuOpen(false);
                        }}
                        className="drawer-item"
                    >
                        👤
                        <span>Profile</span>
                    </div>


                </div>
                <div
                    onClick={handleLogout}
                    className="drawer-item logout"
                    style={{
                        marginTop: "auto",
                        flexShrink: 0
                    }}
                >
                    ⏻
                    <span>Logout</span>
                </div>


            </aside>
        </>
    );
};

export default Sidebar;